import * as R from 'remeda';
import { User } from '../../../types/user';

export const getName = ({
  firstName,
  lastName,
  username,
  email,
}: Partial<User> = {}) =>
  firstName || lastName
    ? `${firstName} ${lastName}`.trim()
    : (username || email)!;

export const splitFullName = (name: string) => {
  const names = name.split(' ');
  const lastName = R.last(names) ?? '';
  const firstName = R.dropLast(names, 1).join(' ');

  return { firstName, lastName };
};
